import { Directive, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
    selector: '[appPreventScroll]',
    standalone: true
})
export class PreventScrollDirective implements OnInit, OnDestroy {
    private renderer = inject(Renderer2);
    private document = inject(DOCUMENT);

    ngOnInit(): void {
        this.renderer.addClass(this.document.body, 'overflow-hidden');
    }

    ngOnDestroy(): void {
        this.renderer.removeClass(this.document.body, 'overflow-hidden');
    }
}
